/* global axios */
import ApiClient from './ApiClient';

class MessageDraftAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/drafts`);
  }

  update(
    conversationId,
    {
      publicContent,
      privateContent,
      ccEmails,
      bccEmails,
      toEmails,
      includeOriginalMessage,
      emailSubject,
    }
  ) {
    const data = {};
    if (publicContent !== undefined) data.public_content = publicContent;
    if (privateContent !== undefined) data.private_content = privateContent;
    if (ccEmails !== undefined) data.cc_emails = ccEmails;
    if (bccEmails !== undefined) data.bcc_emails = bccEmails;
    if (toEmails !== undefined) data.to_emails = toEmails;
    if (includeOriginalMessage !== undefined)
      data.include_original_message = includeOriginalMessage;
    if (emailSubject !== undefined) data.email_subject = emailSubject;
    return axios.patch(`${this.url}/${conversationId}/drafts`, data);
  }

  destroy(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/drafts`);
  }

  addAttachmentBlob(conversationId, blobSignedId, { signal, isPrivate } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/drafts/attachments`,
      { blob_signed_id: blobSignedId, private: isPrivate },
      { signal }
    );
  }

  addAttachmentFile(conversationId, file, { signal, isPrivate } = {}) {
    const formData = new FormData();
    formData.append('attachment', file);
    if (isPrivate) formData.append('private', true);
    return axios.post(
      `${this.url}/${conversationId}/drafts/attachments`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, signal }
    );
  }

  removeAttachment(conversationId, attachmentId) {
    return axios.delete(
      `${this.url}/${conversationId}/drafts/attachments/${attachmentId}`
    );
  }
}

export default new MessageDraftAPI();
